import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material'
import React, { useState } from 'react'
import DefaultModalActions from '../../../../components/GenericModal/DefaultModalActions'
import { type ISection } from '../../../../models/TermsSection'

interface ConfirmGoLiveModalProps {
  handleCloseModal: () => void
  onConfirm: (applyToSections: boolean) => void
  eligibleSections: ISection[]
}

export const ConfirmGoLiveModal = ({
  handleCloseModal,
  onConfirm,
  eligibleSections
}: ConfirmGoLiveModalProps): JSX.Element => {
  const [applyToSections, setApplyToSections] = useState(false)

  return (
    <Box>
      {eligibleSections.length > 0
        ? (
          <Typography>
            {`Going Live will move this Survey Project to Live status. ${eligibleSections.length} Course Section${eligibleSections.length === 1 ? ' has a survey' : 's have surveys'} ready to send to students.`}
          </Typography>
          )
        : (
          <Typography>
            Going Live will move this Survey Project to Live status. No Course Sections are ready to receive surveys yet — students will not receive anything at this time.
          </Typography>
          )}

      {eligibleSections.length > 0 && (
        <Box mt={2}>
          <FormControlLabel
            control={
              <Checkbox
                checked={applyToSections}
                onChange={(e) => { setApplyToSections(e.target.checked) }}
              />
            }
            label='Send surveys to all ready Course Sections now'
          />
        </Box>
      )}

      <DefaultModalActions
        destructiveButtonProps={{ onClick: handleCloseModal }}
        confirmButtonProps={{
          onClick: () => { onConfirm(applyToSections) },
          text: 'Go Live'
        }}
      />
    </Box>
  )
}
